export const gotoBtnText = (authenticated, itemsInCart) => {
  if (!authenticated) {
    return 'Register Now';
  }

  return itemsInCart ? 'Continue Ordering' : 'Start Ordering';
};
